import React, { useCallback, useEffect, useState } from "react";
import MaterialSelect from "components/inputs/material_select";
import styles from "./rate_plan_occupancy_select.module.css";
import moment from "moment";

export default function RatePlanOccupancySelect(props) {
  const {
    rateOccupancy,
    bookerRateOccupancy,
    disabled,
    availableSpaces,
    onChange,
    update,
    cancellationPolicy,
    style = {},
    checkinDate,
    optionsStyle,
  } = props;

  const [options, setOptions] = useState([]);
  const nonrefundable =
    cancellationPolicy && cancellationPolicy?.cancellationPolicyLogic === "non_refundable";
  const deadline = cancellationPolicy && cancellationPolicy?.cancellationPolicyLogic === "deadline";
  const isTimeMeet =
    moment(checkinDate).diff(moment(), "days") >= cancellationPolicy?.cancellationPolicyDeadline;

  useEffect(() => {
    const maxAvailableValue = rateOccupancy + availableSpaces;

    const newOptions = Array.from(Array(maxAvailableValue + 1), (_, index) => {
      if (update && (nonrefundable || (deadline && !isTimeMeet))) {
        return index >= bookerRateOccupancy ? { value: index, key: index } : null;
      } else {
        return { value: index, key: index };
      }
    }).filter(Boolean);

    setOptions(newOptions);
  }, [availableSpaces, rateOccupancy, update, bookerRateOccupancy, deadline, nonrefundable]);

  const handleChange = useCallback(
    (newValue) => {
      onChange(Number(newValue));
    },
    [onChange],
  );

  return (
    <div className={styles.occupancySelectCell}>
      <MaterialSelect
        optionsStyle={optionsStyle}
        style={style}
        disabled={disabled}
        value={rateOccupancy}
        options={options}
        onChange={handleChange}
      />
    </div>
  );
}
